import { Box, Typography } from '@mui/material';

export const PillVariants = {
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  INFO_PURPLE: 'infoPurple',
  INFO_TEAL: 'infoTeal',
};

type PillProps = {
  label: string;
  variant: (typeof PillVariants)[keyof typeof PillVariants];
};

export const Pill = ({ label, variant }: PillProps) => {
  const textColor = getTextColor(variant);
  const backgroundColor = getBackgroundColor(variant);
  return (
    <Box
      sx={{
        px: 1,
        py: 0.5,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: textColor,
        backgroundColor: backgroundColor,
        borderRadius: 2,
      }}>
      <Typography
        variant="caption1Bold"
        color={textColor}
        sx={{ display: 'block' }}>
        {label}
      </Typography>
    </Box>
  );
};

const getTextColor = (variant: PillProps['variant']) => {
  switch (variant) {
    case PillVariants.WARNING:
      return 'orange200';
    case PillVariants.ERROR:
      return 'red200';
    case PillVariants.SUCCESS:
      return 'green200';
    case PillVariants.INFO_PURPLE:
      return 'purple200';
    case PillVariants.INFO_TEAL:
      return 'teal200';
    case PillVariants.INFO:
    default:
      return 'blue200';
  }
};

const getBackgroundColor = (variant: PillProps['variant']) => {
  switch (variant) {
    case PillVariants.WARNING:
      return 'orange50';
    case PillVariants.ERROR:
      return 'red50';
    case PillVariants.SUCCESS:
      return 'green50';
    case PillVariants.INFO_PURPLE:
      return 'purple50';
    case PillVariants.INFO_TEAL:
      return 'teal50';
    case PillVariants.INFO:
    default:
      return 'blue50';
  }
};
